<template>
    <div class="processes" :style="{minHeight:minheight + 'px'}">
        <div class="banner">
            <img src="../assets/proce-banner.png">
            <p>临床研究CRC可信服务平台业务流程</p>
        </div>
        <div class="content-continer">
            <ul>
                <li>
                    <div class="entrance">
                        <img src="../assets/person1.png">
                        <p>个人用户</p>
                    </div>
                    <div class="processes-btn">
                        <img src="../assets/zcicon.png">注册
                    </div>
                    <div class="jt-icon">
                        <img src="../assets/righticon.png">
                    </div>
                    <div class="processes-btn">
                        <img src="../assets/loginicon.png">登录
                    </div>
                    <div class="jt-icon">
                        <img src="../assets/righticon.png">
                    </div>
                    <div class="processes-btn">
                        <img src="../assets/wsicon.png">完善个人简历
                    </div>
                    <p style="clear: both;"></p>
                </li>
                <li>
                    <div class="entrance">
                        <img src="../assets/companyicon.png">
                        <p>企业用户</p>
                    </div>
                    <div class="processes-btn">
                        <img src="../assets/zcicon.png">注册
                    </div>
                    <div class="jt-icon">
                        <img src="../assets/righticon.png">
                    </div>
                    <div class="processes-btn">
                        <img src="../assets/login2icon.png">登录
                    </div>
                    <div class="jt-icon">
                        <img src="../assets/righticon.png">
                    </div>
                    <div class="processes-btn">
                        <img src="../assets/addcrc.png">CRC人员添加
                    </div>
                    <div class="jt-icon" style="margin-left: 20px;">
                        <img src="../assets/xicon.png">
                    </div>
                    <div class="processes-btn" style="float: right;margin-top: -13px;margin-right: 15px">
                        <img src="../assets/addcrc.png">CRC人员委派
                    </div>
                    <p style="clear: both;"></p>
                </li>
                <li>
                    <div class="entrance">
                        <img src="../assets/hosptilicon.png">
                        <p>医院用户</p>
                    </div>
                    <div class="processes-btn">
                        <img src="../assets/zcicon.png">注册
                    </div>
                    <div class="jt-icon">
                        <img src="../assets/righticon.png">
                    </div>
                    <div class="processes-btn">
                        <img src="../assets/login2icon.png">登录
                    </div>
                    <div class="jt-icon">
                        <img src="../assets/righticon.png">
                    </div>
                    <div class="processes-btn">
                        <img src="../assets/newicon.png">新建项目
                    </div>
                    <div class="jt-icon" style="margin-left: 20px;">
                        <img src="../assets/xicon.png">
                    </div>
                    <div class="processes-btn" style="float: right;margin-top: -13px;margin-right: 15px">
                        <img src="../assets/jsicon.png">CRC人员接收
                    </div>
                    <div class="jt-icon" style="float: right;margin-top:-22px;">
                            <img src="../assets/lefticon.png">
                        </div>
                    <div class="processes-btn" style="float: right;margin-top: -13px;margin-right: 15px">
                            <img src="../assets/pjicon.png">CRC人员评价
                        </div>
                    <p style="clear: both;"></p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'processes',
        data() {
            return {
                msg: 'Welcome to Your Vue.js App',
                minheight: this.Common.minheight,
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .banner {
        width: 100%;
        height: 120px;
        position: relative;

    }

    .banner img {
        width: 100%;
        height: 100%;
    }

    .banner p {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        font-size: 30px;
        color: #fff;
        line-height: 120px;
        text-align: center;
    }

    ul li {
        color: #3672BF;
        padding: 33px 0px;
        border-bottom: 1px solid rgba(230, 230, 230, 1);
    }

    ul li>div {
        float: left
    }

    .entrance {
        /* text-align: center; */
        font-size: 16px;
        margin-right: 100px;
    }

    .entrance p {
        margin-top: 10px;
        font-weight: bold;
    }

    .processes-btn {
        width: 200px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        background: rgba(245, 245, 245, 1);
        font-weight: bold;
        margin-top: 13px;
        font-size: 15px;
    }

    .processes-btn img {
        vertical-align: middle;
        margin-right: 20px;
    }

    .jt-icon {
        padding: 30px 59px;
    }
</style>


// WEBPACK FOOTER //
// src/components/processes.vue